import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/envs/environnement';

// Verifie que l'abonnement de la structure courante est actif avant de laisser
// passer vers une page du dashboard. Applique en canActivateChild (voir
// app-routing.module.ts) pour se redeclencher a chaque changement de page dans
// le tableau de bord, pas seulement au premier chargement.
@Injectable({
  providedIn: 'root'
})
export class TrialGuard implements CanActivateChild {

  // La page "Mon abonnement" (dans Parametres) doit rester accessible meme
  // abonnement inactif : sinon impossible de payer pour le reactiver.
  private static readonly ROUTES_EXEMPTEES = ['parametres'];

  constructor(private router: Router, private http: HttpClient) {}

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {

      if (TrialGuard.ROUTES_EXEMPTEES.includes(route.routeConfig?.path ?? '')) {
        return true;
      }

      // Aucune structure encore selectionnee (dropdown "Charger une entreprise"
      // pas encore utilise) : rien a verifier pour l'instant, on laisse passer
      // plutot que de bloquer avant meme que l'utilisateur ait pu choisir.
      const structureId = sessionStorage.getItem('courrante');
      if (!structureId) {
        return true;
      }

      return this.http.get<boolean>(`${environment.baseUrl}/subscriptions/structure/${structureId}/active`).pipe(
        map(isActive => {
          if (!isActive) {
            this.router.navigate(['/dashboard/parametres']);
            return false;
          }
          return true;
        }),
        catchError((err) => {
          console.error('Erreur lors de la verification de l\'abonnement', err);
          // Ne bloque pas l'acces sur une simple erreur reseau/technique :
          // seul un abonnement confirme inactif doit rediriger.
          return of(true);
        })
      );
  }
}
